/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditPasswordDto } from '../../models/edit-password-dto';
import { GenericMessageDto } from '../../models/generic-message-dto';

export interface AuthControllerSetPassword$Params {
  body: EditPasswordDto;
}

export function authControllerSetPassword(
  http: HttpClient,
  rootUrl: string,
  params: AuthControllerSetPassword$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GenericMessageDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerSetPassword.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericMessageDto>;
      }),
    );
}

authControllerSetPassword.PATH = '/auth/set-password';
